import React from 'react';

interface ISuspenseLoader extends React.PropsWithChildren {
  loading: boolean;
  fallBack: React.ReactElement;
}

const SuspenseLoader: React.FC<ISuspenseLoader> = props => {
  const { fallBack, loading, children } = props;
  if (loading) return fallBack;
  return <>{children}</>;
};

export default SuspenseLoader;

/*
 *  USAGE
    <SuspenseLoader
        loading={pageDetail?.customerName}
        fallBack={<LineLoader lineWidth={100} dimenshionUnit="px" numberOfLines={1} childrenType= {"H1"} />}
    >
        <Typography variant={'h2'}>{pageDetail?.customerName}</Typography>
    </SuspenseLoader>
 * */
